var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollorCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 364,
    viewBox: "0 0 279 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_831)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 279,
    height: 364,
    rx: 10,
    fill: "#1AD079"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4923 23.5738C38.9061 25.5549 39.631 27.4387 39.7172 29.2301L39.7646 30.2162L40.5315 29.5945L44.3096 26.5318L44.5249 26.3573L44.491 26.0822C44.3083 24.599 43.2803 22.6626 41.5231 20.3062L44.2552 18.0915L44.6436 17.7766L44.3287 17.3882L42.5684 15.2167L42.2535 14.8282L41.8651 15.1431L39.0211 17.4486C37.2113 15.8532 35.1633 14.9418 32.8856 14.7355C30.4754 14.5064 28.327 15.1463 26.4701 16.6516C24.9115 17.9151 23.8921 19.4514 23.4387 21.2564L23.4379 21.2598C23.0033 23.0422 23.2838 25.8033 24.1919 29.4697L16.9811 35.3151C16.2864 34.3673 15.6906 33.2243 15.1981 31.8791C14.6442 30.3516 14.399 29.0218 14.438 27.8807L14.4754 26.7846L13.6234 27.4753L9.68634 30.6668L9.46991 30.8423L9.50524 31.1186C9.81838 33.5684 10.9822 36.0572 12.9499 38.5829L9.6447 41.2623L9.25629 41.5771L9.57115 41.9656L11.3315 44.1371L11.6464 44.5255L12.0348 44.2107L15.5354 41.3729C17.5273 43.1091 19.596 44.1251 21.7403 44.3711C24.0084 44.6312 26.0708 44.0086 27.9007 42.5252C29.4203 41.2933 30.3705 39.6753 30.7489 37.6949C31.1162 35.7719 30.8497 33.0728 30.0076 29.6412L37.4923 23.5738ZM32.8776 20.0697C33.5756 20.105 34.2557 20.3325 34.9215 20.7719L29.0387 25.5407C28.8798 24.4472 28.8883 23.6006 29.0373 22.9809C29.2154 22.2399 29.6797 21.5395 30.487 20.8851C31.2217 20.2895 32.0124 20.026 32.8776 20.0697ZM19.5759 38.0975L25.2097 33.5305C25.5223 35.8495 25.0559 37.3416 24.0074 38.1916C23.2618 38.796 22.5084 39.0392 21.73 38.9737C21.074 38.9184 20.3569 38.64 19.5759 38.0975Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.646 5.62048C112.825 6.70384 114.351 8.02534 115.269 9.56577L115.775 10.4137L116.159 9.50438L118.053 5.02458L118.161 4.76932L118.002 4.54254C117.143 3.3195 115.325 2.09419 112.666 0.841037L114.035 -2.39834L114.23 -2.85888L113.77 -3.05357L111.195 -4.14204L110.734 -4.33672L110.539 -3.87618L109.114 -0.504023C106.766 -1.06074 104.53 -0.901831 102.423 -0.0126971C100.189 0.91873 98.5937 2.49383 97.6629 4.69563C96.8817 6.54363 96.7047 8.3789 97.1535 10.185L97.1543 10.1884C97.6091 11.9658 99.1553 14.2705 101.681 17.079L98.0667 25.6289C97.0079 25.1193 95.9445 24.3907 94.8772 23.4352C93.67 22.3478 92.8282 21.2895 92.3259 20.2642L91.8434 19.2793L91.4163 20.2895L89.4429 24.9577L89.3345 25.2143L89.4956 25.4416C90.9241 27.4562 93.1217 29.1052 96.0461 30.4087L94.3894 34.3277L94.1947 34.7883L94.6553 34.983L97.2301 36.0714L97.6907 36.2661L97.8854 35.8056L99.64 31.6549C102.214 32.2502 104.518 32.1739 106.526 31.3825C108.65 30.5453 110.177 29.0259 111.094 26.8561C111.856 25.0543 111.934 23.1795 111.336 21.2538C110.756 19.3841 109.251 17.1274 106.894 14.4951L110.646 5.62048ZM104.925 4.69853C105.558 4.40136 106.265 4.2823 107.059 4.35691L104.11 11.3321C103.456 10.4419 103.065 9.69074 102.905 9.07377C102.714 8.33608 102.794 7.49963 103.199 6.54239C103.567 5.67128 104.141 5.06685 104.925 4.69853ZM101.665 26.864L104.489 20.184C105.856 22.0834 106.146 23.6196 105.62 24.8628C105.246 25.7469 104.696 26.3159 103.978 26.6241C103.373 26.8839 102.61 26.9754 101.665 26.864Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.259 119.309C116.743 116.923 117.626 115.108 118.877 113.823L119.566 113.116L118.588 112.979L113.772 112.306L113.497 112.267L113.319 112.48C112.359 113.625 111.644 115.698 111.12 118.59L107.637 118.103L107.142 118.034L107.072 118.529L106.685 121.297L106.616 121.792L107.111 121.862L110.737 122.369C110.805 124.78 111.535 126.9 112.938 128.706C114.415 130.625 116.348 131.759 118.715 132.09C120.702 132.368 122.521 132.066 124.15 131.166L124.153 131.164C125.753 130.266 127.581 128.178 129.643 125.013L138.836 126.298C138.616 127.453 138.187 128.668 137.539 129.946C136.8 131.393 135.995 132.479 135.134 133.229L134.307 133.949L135.393 134.101L140.412 134.803L140.688 134.842L140.866 134.628C142.444 132.728 143.47 130.179 143.975 127.017L148.189 127.606L148.684 127.676L148.753 127.181L149.14 124.412L149.21 123.917L148.714 123.848L144.251 123.223C144.162 120.583 143.494 118.377 142.211 116.641C140.855 114.805 138.992 113.722 136.659 113.395C134.722 113.124 132.891 113.533 131.185 114.608C129.528 115.651 127.736 117.687 125.801 120.643L116.259 119.309ZM116.844 125.073C116.394 124.539 116.096 123.886 115.964 123.1L123.463 124.149C122.772 125.011 122.147 125.582 121.593 125.896C120.929 126.271 120.1 126.409 119.071 126.265C118.134 126.134 117.402 125.736 116.844 125.073ZM139.1 122.503L131.918 121.499C133.4 119.688 134.81 119.011 136.146 119.198C137.097 119.331 137.789 119.716 138.272 120.33C138.679 120.848 138.964 121.562 139.1 122.503Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter3_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6525 150.807C27.7443 149.563 29.6818 148.997 31.4743 149.06L32.4608 149.095L31.9051 148.279L29.1671 144.259L29.0111 144.03L28.7342 144.041C27.2409 144.1 25.2258 144.964 22.7314 146.519L20.7515 143.612L20.4701 143.199L20.0568 143.48L17.7464 145.054L17.3331 145.335L17.6146 145.749L19.6756 148.774C17.9353 150.445 16.8567 152.41 16.4617 154.663C16.033 157.046 16.4921 159.24 17.8378 161.216C18.9672 162.874 20.4135 164.017 22.1745 164.619L22.1778 164.621C23.9179 165.202 26.6928 165.152 30.422 164.552L35.6476 172.224C34.6453 172.837 33.4567 173.336 32.0752 173.715C30.5069 174.14 29.1613 174.274 28.0275 174.14L26.9382 174.011L27.5557 174.918L30.4088 179.107L30.5656 179.337L30.844 179.325C33.3112 179.216 35.8882 178.264 38.5689 176.513L40.9641 180.029L41.2456 180.442L41.6588 180.161L43.9692 178.587L44.3825 178.306L44.101 177.893L41.5642 174.168C43.46 172.328 44.6445 170.35 45.0679 168.234C45.5158 165.995 45.0668 163.888 43.7407 161.941C42.6395 160.325 41.106 159.243 39.1639 158.702C37.2782 158.176 34.5662 158.217 31.0765 158.771L25.6525 150.807ZM21.7768 155.115C21.87 154.422 22.1533 153.763 22.6465 153.136L26.9096 159.395C25.8067 159.462 24.9637 159.384 24.3586 159.184C23.635 158.944 22.9756 158.424 22.3906 157.565C21.8582 156.783 21.6613 155.973 21.7768 155.115ZM38.6361 169.869L34.5534 163.875C36.8903 163.756 38.3385 164.345 39.0983 165.461C39.6386 166.254 39.8184 167.025 39.6884 167.795C39.5787 168.445 39.2416 169.136 38.6361 169.869Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter4_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2766 83.1404C66.7103 83.1566 68.6615 83.6738 70.1632 84.6543L70.9898 85.194L70.9358 84.2083L70.6699 79.3519L70.6547 79.0752L70.412 78.9414C69.1033 78.2198 66.932 77.9173 63.9928 77.9592L63.8005 74.4475L63.7732 73.9483L63.2739 73.9756L60.4826 74.1285L59.9834 74.1558L60.0107 74.6551L60.2109 78.3107C57.8574 78.8414 55.9184 79.9661 54.4158 81.6903C52.8171 83.5085 52.0759 85.624 52.2066 88.0109C52.3164 90.0142 52.9633 91.7408 54.1596 93.1663L54.1619 93.169C55.351 94.5661 57.7522 95.9577 61.2548 97.3717L61.7624 106.64C60.5873 106.647 59.312 106.46 57.9335 106.07C56.3713 105.623 55.1503 105.042 54.2488 104.342L53.3828 103.669L53.4428 104.764L53.7199 109.824L53.7351 110.103L53.9797 110.236C56.1478 111.419 58.8463 111.935 62.0461 111.822L62.2788 116.07L62.3061 116.57L62.8054 116.542L65.5966 116.389L66.0959 116.362L66.0686 115.863L65.8221 111.363C68.3964 110.767 70.4324 109.687 71.8888 108.094C73.4294 106.41 74.1342 104.374 74.0054 102.022C73.8984 100.068 73.1448 98.35 71.7622 96.8824C70.4198 95.4574 68.077 94.0907 64.8034 92.761L64.2766 83.1404ZM58.7324 84.8242C59.1702 84.2794 59.7533 83.8619 60.4995 83.5802L60.9136 91.1417C59.9346 90.6293 59.2537 90.1261 58.8391 89.6421C58.3433 89.0633 58.0481 88.2765 57.9913 87.2389C57.9395 86.2945 58.1897 85.4995 58.7324 84.8242ZM65.5377 106.17L65.1411 98.928C67.203 100.034 68.1383 101.287 68.2121 102.635C68.2646 103.593 68.0199 104.346 67.5105 104.938C67.081 105.437 66.4351 105.855 65.5377 106.17Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter5_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.818 47.7059C163.247 47.8551 165.167 48.4782 166.613 49.5394L167.409 50.1236V49.1364V44.2727V43.9956L167.174 43.8487C165.907 43.0566 163.755 42.6359 160.818 42.5169V39V38.5H160.318H157.523H157.023V39V42.6611C154.644 43.0624 152.646 44.0793 151.051 45.7188C149.356 47.4468 148.5 49.5186 148.5 51.9091C148.5 53.9154 149.052 55.6748 150.168 57.1636L150.17 57.1664C151.281 58.6265 153.603 60.1473 157.023 61.7506V71.0331C155.849 70.976 154.586 70.719 153.231 70.2545C151.695 69.7229 150.508 69.0759 149.646 68.3271L148.818 67.6078V68.7045V73.7727V74.0513L149.055 74.1979C151.155 75.4973 153.822 76.1605 157.023 76.2225V80.4773V80.9773H157.523H160.318H160.818V80.4773V75.9709C163.421 75.5169 165.513 74.5497 167.055 73.0389C168.685 71.4408 169.5 69.4466 169.5 67.0909C169.5 65.1348 168.841 63.3777 167.541 61.8367C166.279 60.3404 164.014 58.8477 160.818 57.3409V47.7059ZM155.19 49.0841C155.657 48.564 156.262 48.179 157.023 47.9385V55.5113C156.073 54.9462 155.421 54.4065 155.033 53.9005C154.57 53.2955 154.318 52.4938 154.318 51.4545C154.318 50.5088 154.611 49.7286 155.19 49.0841ZM160.818 70.7696V63.5172C162.816 64.7346 163.682 66.0366 163.682 67.3864C163.682 68.3462 163.396 69.0846 162.855 69.648C162.399 70.1228 161.731 70.5045 160.818 70.7696Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter6_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5707 227.947C68.4402 226.389 70.2643 225.525 72.0443 225.304L73.024 225.183L72.3466 224.465L69.0092 220.927L68.819 220.726L68.5473 220.78C67.0819 221.074 65.2281 222.244 63.01 224.173L60.5967 221.614L60.2536 221.251L59.8899 221.594L57.8564 223.512L57.4927 223.855L57.8358 224.219L60.3481 226.882C58.8929 228.806 58.1377 230.917 58.1027 233.204C58.055 235.624 58.8542 237.719 60.4945 239.457C61.8713 240.917 63.4797 241.818 65.3136 242.135L65.3171 242.136C67.1271 242.435 69.8594 241.949 73.4473 240.768L79.817 247.52C78.924 248.284 77.8288 248.964 76.5244 249.556C75.0427 250.223 73.735 250.567 72.5943 250.614L71.4984 250.659L72.251 251.456L75.7288 255.143L75.92 255.346L76.1929 255.29C78.6123 254.794 81.0068 253.447 83.3779 251.295L86.2976 254.39L86.6407 254.754L87.0044 254.411L89.0378 252.492L89.4015 252.149L89.0584 251.786L85.9661 248.508C87.5481 246.391 88.4061 244.252 88.4906 242.095C88.5799 239.814 87.8044 237.804 86.1879 236.091C84.8456 234.668 83.1609 233.842 81.1577 233.613C79.2126 233.391 76.541 233.859 73.1822 234.956L66.5707 227.947ZM63.4225 232.812C63.4054 232.113 63.5813 231.418 63.9694 230.721L69.1659 236.229C68.0875 236.47 67.2426 236.525 66.6134 236.423C65.8612 236.301 65.128 235.89 64.4148 235.134C63.7659 234.446 63.4438 233.678 63.4225 232.812ZM82.397 244.724L77.4204 239.449C79.7094 238.963 81.2323 239.316 82.1585 240.298C82.8171 240.996 83.1162 241.729 83.1092 242.51C83.1033 243.169 82.8794 243.905 82.397 244.724Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter7_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2528 169.988C100.595 169.328 102.613 169.283 104.328 169.808L105.272 170.097L104.947 169.165L103.343 164.574L103.251 164.312L102.981 164.251C101.523 163.921 99.3534 164.233 96.5414 165.09L95.3815 161.77L95.2166 161.298L94.7446 161.463L92.1055 162.385L91.6335 162.549L91.7984 163.021L93.0059 166.478C90.8924 167.641 89.3419 169.26 88.3772 171.334C87.3464 173.524 87.2218 175.762 88.0102 178.019C88.6719 179.913 89.7729 181.392 91.3181 182.43L91.3209 182.431C92.8513 183.443 95.5445 184.113 99.3019 184.499L102.363 193.262C101.237 193.595 99.9593 193.769 98.5269 193.778C96.902 193.782 95.5677 193.563 94.5071 193.141L93.4882 192.734L93.85 193.77L95.5215 198.554L95.6134 198.818L95.8854 198.878C98.2967 199.412 101.032 199.158 104.075 198.161L105.478 202.178L105.643 202.65L106.115 202.485L108.754 201.563L109.226 201.398L109.061 200.926L107.575 196.672C109.883 195.385 111.539 193.782 112.495 191.847C113.508 189.801 113.619 187.649 112.842 185.425C112.197 183.579 110.996 182.137 109.26 181.111C107.575 180.115 104.945 179.453 101.431 179.084L98.2528 169.988ZM93.3943 173.146C93.6636 172.501 94.1078 171.938 94.7465 171.46L97.2441 178.609C96.1614 178.389 95.3675 178.094 94.8347 177.744C94.1977 177.326 93.6957 176.652 93.3529 175.671C93.041 174.778 93.0605 173.945 93.3943 173.146ZM105.86 191.762L103.468 184.915C105.756 185.405 107.002 186.349 107.447 187.623C107.764 188.529 107.738 189.321 107.413 190.031C107.139 190.63 106.634 191.21 105.86 191.762Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter8_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.054 214.048C218.469 214.345 220.348 215.084 221.726 216.232L222.485 216.863L222.545 215.878L222.842 211.023L222.859 210.747L222.633 210.586C221.416 209.718 219.295 209.167 216.37 208.869L216.585 205.359L216.615 204.859L216.116 204.829L213.326 204.658L212.827 204.628L212.796 205.127L212.573 208.781C210.174 209.037 208.118 209.93 206.426 211.469C204.628 213.09 203.648 215.106 203.502 217.492C203.38 219.495 203.823 221.285 204.847 222.839L204.849 222.842C205.868 224.367 208.093 226.026 211.409 227.835L210.843 237.101C209.675 236.972 208.429 236.638 207.105 236.092C205.605 235.468 204.459 234.75 203.645 233.95L202.862 233.181L202.795 234.276L202.486 239.335L202.469 239.613L202.697 239.773C204.714 241.199 207.335 242.023 210.526 242.28L210.266 246.527L210.236 247.026L210.735 247.057L213.525 247.227L214.024 247.258L214.055 246.759L214.33 242.261C216.956 241.966 219.103 241.128 220.733 239.714C222.458 238.219 223.393 236.278 223.537 233.927C223.656 231.974 223.106 230.18 221.902 228.563C220.734 226.992 218.564 225.364 215.466 223.665L216.054 214.048ZM210.352 215.081C210.85 214.59 211.477 214.243 212.251 214.049L211.789 221.608C210.876 220.986 210.258 220.407 209.902 219.878C209.476 219.246 209.274 218.431 209.337 217.393C209.395 216.449 209.735 215.689 210.352 215.081ZM214.647 237.069L215.089 229.83C217.01 231.167 217.794 232.519 217.712 233.867C217.653 234.825 217.323 235.544 216.749 236.074C216.265 236.52 215.575 236.86 214.647 237.069Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter9_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.571 116.947C230.44 115.389 232.264 114.525 234.044 114.304L235.024 114.183L234.347 113.465L231.009 109.927L230.819 109.726L230.547 109.78C229.082 110.074 227.228 111.244 225.01 113.173L222.597 110.614L222.254 110.251L221.89 110.594L219.856 112.512L219.493 112.855L219.836 113.219L222.348 115.882C220.893 117.806 220.138 119.917 220.103 122.204C220.055 124.624 220.854 126.719 222.495 128.457C223.871 129.917 225.48 130.818 227.314 131.135L227.317 131.136C229.127 131.435 231.859 130.949 235.447 129.768L241.817 136.52C240.924 137.284 239.829 137.964 238.524 138.556C237.043 139.223 235.735 139.567 234.594 139.614L233.498 139.659L234.251 140.456L237.729 144.143L237.92 144.346L238.193 144.29C240.612 143.794 243.007 142.447 245.378 140.295L248.298 143.39L248.641 143.754L249.004 143.411L251.038 141.492L251.402 141.149L251.058 140.786L247.966 137.508C249.548 135.391 250.406 133.252 250.491 131.095C250.58 128.814 249.804 126.804 248.188 125.091C246.846 123.668 245.161 122.842 243.158 122.613C241.213 122.391 238.541 122.859 235.182 123.956L228.571 116.947ZM225.423 121.812C225.405 121.113 225.581 120.418 225.969 119.721L231.166 125.229C230.087 125.47 229.243 125.525 228.613 125.423C227.861 125.301 227.128 124.89 226.415 124.134C225.766 123.446 225.444 122.678 225.423 121.812ZM244.397 133.724L239.42 128.449C241.709 127.963 243.232 128.316 244.158 129.298C244.817 129.996 245.116 130.729 245.109 131.51C245.103 132.169 244.879 132.905 244.397 133.724Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter10_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.571 157.947C169.44 156.389 171.264 155.525 173.044 155.304L174.024 155.183L173.347 154.465L170.009 150.927L169.819 150.726L169.547 150.78C168.082 151.074 166.228 152.244 164.01 154.173L161.597 151.614L161.254 151.251L160.89 151.594L158.856 153.512L158.493 153.855L158.836 154.219L161.348 156.882C159.893 158.806 159.138 160.917 159.103 163.204C159.055 165.624 159.854 167.719 161.495 169.457C162.871 170.917 164.48 171.818 166.314 172.135L166.317 172.136C168.127 172.435 170.859 171.949 174.447 170.768L180.817 177.52C179.924 178.284 178.829 178.964 177.524 179.556C176.043 180.223 174.735 180.567 173.594 180.614L172.498 180.659L173.251 181.456L176.729 185.143L176.92 185.346L177.193 185.29C179.612 184.794 182.007 183.447 184.378 181.295L187.298 184.39L187.641 184.754L188.004 184.411L190.038 182.492L190.402 182.149L190.058 181.786L186.966 178.508C188.548 176.391 189.406 174.252 189.491 172.095C189.58 169.814 188.804 167.804 187.188 166.091C185.846 164.668 184.161 163.842 182.158 163.613C180.213 163.391 177.541 163.859 174.182 164.956L167.571 157.947ZM164.423 162.812C164.405 162.113 164.581 161.418 164.969 160.721L170.166 166.229C169.087 166.47 168.243 166.525 167.613 166.423C166.861 166.301 166.128 165.89 165.415 165.134C164.766 164.446 164.444 163.678 164.423 162.812ZM183.397 174.724L178.42 169.449C180.709 168.963 182.232 169.316 183.158 170.298C183.817 170.996 184.116 171.729 184.109 172.51C184.103 173.169 183.879 173.905 183.397 174.724Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter11_d_270_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.211 20.0344C212.241 18.6917 214.149 18.034 215.943 18.0115L216.93 17.9991L216.336 17.2106L213.409 13.3262L213.242 13.1049L212.966 13.129C211.477 13.259 209.506 14.2177 207.088 15.8902L204.972 13.0813L204.671 12.682L204.272 12.9829L202.039 14.6651L201.64 14.966L201.941 15.3653L204.144 18.2893C202.485 20.0414 201.502 22.0558 201.215 24.3248C200.9 26.7253 201.464 28.895 202.902 30.8042C204.11 32.4065 205.609 33.4798 207.397 33.9969L207.4 33.9978C209.166 34.4954 211.935 34.313 215.631 33.5355L221.217 40.9491C220.246 41.6097 219.082 42.1646 217.72 42.609C216.174 43.1085 214.837 43.3063 213.698 43.2269L212.603 43.1506L213.264 44.0266L216.313 48.0744L216.481 48.2969L216.759 48.2714C219.218 48.0453 221.746 46.9705 224.34 45.0936L226.901 48.4918L227.202 48.8911L227.601 48.5902L229.834 46.908L230.233 46.6071L229.932 46.2077L227.22 42.6087C229.026 40.6796 230.115 38.6483 230.437 36.5141C230.777 34.2566 230.228 32.1734 228.81 30.292C227.633 28.7297 226.05 27.7227 224.084 27.2744C222.175 26.8391 219.468 27.0097 216.009 27.7295L210.211 20.0344ZM206.545 24.5219C206.605 23.8256 206.857 23.1539 207.32 22.5042L211.877 28.5524C210.778 28.6724 209.933 28.6339 209.319 28.463C208.584 28.2587 207.901 27.7699 207.276 26.9399C206.706 26.1845 206.471 25.385 206.545 24.5219ZM224.09 38.4545L219.726 32.6623C222.054 32.4322 223.529 32.9512 224.341 34.0292C224.919 34.7958 225.135 35.5573 225.042 36.3329C224.964 36.9865 224.66 37.6933 224.09 38.4545Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.1641 283.797L47.1406 295H45.0625L41.1094 283.797H43.1406L45.9062 292.297C45.9948 292.568 46.0625 292.883 46.1094 293.242H46.1406C46.1771 292.945 46.2526 292.625 46.3672 292.281L49.1953 283.797H51.1641ZM53.3594 285.32C53.0625 285.32 52.8073 285.224 52.5938 285.031C52.3854 284.839 52.2812 284.594 52.2812 284.297C52.2812 284 52.3854 283.753 52.5938 283.555C52.8073 283.357 53.0625 283.258 53.3594 283.258C53.6667 283.258 53.9271 283.357 54.1406 283.555C54.3542 283.753 54.4609 284 54.4609 284.297C54.4609 284.578 54.3542 284.82 54.1406 285.023C53.9271 285.221 53.6667 285.32 53.3594 285.32ZM54.2578 295H52.4453V287H54.2578V295ZM63.4062 291.492H57.9531C57.974 292.232 58.2005 292.802 58.6328 293.203C59.0703 293.604 59.6693 293.805 60.4297 293.805C61.2839 293.805 62.0677 293.549 62.7812 293.039V294.5C62.0521 294.958 61.0885 295.188 59.8906 295.188C58.7135 295.188 57.7891 294.826 57.1172 294.102C56.4505 293.372 56.1172 292.349 56.1172 291.031C56.1172 289.786 56.4844 288.773 57.2188 287.992C57.9583 287.206 58.875 286.812 59.9688 286.812C61.0625 286.812 61.9089 287.164 62.5078 287.867C63.1068 288.57 63.4062 289.547 63.4062 290.797V291.492ZM61.6562 290.211C61.651 289.56 61.4974 289.055 61.1953 288.695C60.8932 288.331 60.4766 288.148 59.9453 288.148C59.4245 288.148 58.9818 288.339 58.6172 288.719C58.2578 289.099 58.0365 289.596 57.9531 290.211H61.6562ZM75.8906 287L73.5312 295H71.6328L70.1797 289.578C70.1224 289.37 70.0859 289.135 70.0703 288.875H70.0391C70.0286 289.052 69.9818 289.281 69.8984 289.562L68.3203 295H66.4609L64.1094 287H65.9844L67.4375 292.766C67.4844 292.938 67.5156 293.167 67.5312 293.453H67.5859C67.6016 293.234 67.6432 293 67.7109 292.75L69.3281 287H71.0312L72.4688 292.789C72.5156 292.971 72.5495 293.201 72.5703 293.477H72.625C72.6354 293.284 72.6745 293.055 72.7422 292.789L74.1641 287H75.8906ZM83.4922 293.82H83.4609V298.68H81.6484V287H83.4609V288.406H83.4922C84.112 287.344 85.0182 286.812 86.2109 286.812C87.2266 286.812 88.0182 287.169 88.5859 287.883C89.1536 288.596 89.4375 289.555 89.4375 290.758C89.4375 292.091 89.1172 293.159 88.4766 293.961C87.8359 294.763 86.9609 295.164 85.8516 295.164C84.8307 295.164 84.0443 294.716 83.4922 293.82ZM83.4453 290.664V291.656C83.4453 292.24 83.6302 292.734 84 293.141C84.375 293.547 84.849 293.75 85.4219 293.75C86.0938 293.75 86.6198 293.49 87 292.969C87.3854 292.443 87.5781 291.711 87.5781 290.773C87.5781 289.987 87.3984 289.372 87.0391 288.93C86.6849 288.482 86.2031 288.258 85.5938 288.258C84.9479 288.258 84.4271 288.487 84.0312 288.945C83.6406 289.404 83.4453 289.977 83.4453 290.664ZM95.9297 288.727C95.7109 288.555 95.3958 288.469 94.9844 288.469C94.4479 288.469 94 288.711 93.6406 289.195C93.2812 289.68 93.1016 290.339 93.1016 291.172V295H91.2891V287H93.1016V288.648H93.1328C93.3099 288.086 93.5807 287.648 93.9453 287.336C94.3151 287.018 94.7266 286.859 95.1797 286.859C95.5078 286.859 95.7578 286.909 95.9297 287.008V288.727ZM98.125 285.32C97.8281 285.32 97.5729 285.224 97.3594 285.031C97.151 284.839 97.0469 284.594 97.0469 284.297C97.0469 284 97.151 283.753 97.3594 283.555C97.5729 283.357 97.8281 283.258 98.125 283.258C98.4323 283.258 98.6927 283.357 98.9062 283.555C99.1198 283.753 99.2266 284 99.2266 284.297C99.2266 284.578 99.1198 284.82 98.9062 285.023C98.6927 285.221 98.4323 285.32 98.125 285.32ZM99.0234 295H97.2109V287H99.0234V295ZM107.125 294.633C106.484 295.003 105.727 295.188 104.852 295.188C103.664 295.188 102.706 294.818 101.977 294.078C101.247 293.333 100.883 292.37 100.883 291.188C100.883 289.87 101.273 288.812 102.055 288.016C102.841 287.214 103.891 286.812 105.203 286.812C105.932 286.812 106.576 286.94 107.133 287.195V288.883C106.576 288.466 105.982 288.258 105.352 288.258C104.586 288.258 103.958 288.518 103.469 289.039C102.979 289.555 102.734 290.232 102.734 291.07C102.734 291.898 102.964 292.552 103.422 293.031C103.885 293.51 104.505 293.75 105.281 293.75C105.932 293.75 106.547 293.518 107.125 293.055V294.633ZM109.844 285.32C109.547 285.32 109.292 285.224 109.078 285.031C108.87 284.839 108.766 284.594 108.766 284.297C108.766 284 108.87 283.753 109.078 283.555C109.292 283.357 109.547 283.258 109.844 283.258C110.151 283.258 110.411 283.357 110.625 283.555C110.839 283.753 110.945 284 110.945 284.297C110.945 284.578 110.839 284.82 110.625 285.023C110.411 285.221 110.151 285.32 109.844 285.32ZM110.742 295H108.93V287H110.742V295ZM120.242 295H118.43V290.492C118.43 288.997 117.901 288.25 116.844 288.25C116.292 288.25 115.836 288.458 115.477 288.875C115.117 289.286 114.938 289.807 114.938 290.438V295H113.117V287H114.938V288.328H114.969C115.568 287.318 116.432 286.812 117.562 286.812C118.432 286.812 119.096 287.096 119.555 287.664C120.013 288.227 120.242 289.042 120.242 290.109V295ZM129.742 294.359C129.742 297.297 128.266 298.766 125.312 298.766C124.271 298.766 123.362 298.591 122.586 298.242V296.586C123.461 297.086 124.292 297.336 125.078 297.336C126.979 297.336 127.93 296.401 127.93 294.531V293.656H127.898C127.299 294.677 126.398 295.188 125.195 295.188C124.221 295.188 123.435 294.833 122.836 294.125C122.242 293.411 121.945 292.456 121.945 291.258C121.945 289.898 122.266 288.818 122.906 288.016C123.547 287.214 124.427 286.812 125.547 286.812C126.604 286.812 127.388 287.245 127.898 288.109H127.93V287H129.742V294.359ZM127.945 291.336V290.297C127.945 289.734 127.758 289.255 127.383 288.859C127.013 288.458 126.549 288.258 125.992 288.258C125.305 288.258 124.766 288.513 124.375 289.023C123.99 289.529 123.797 290.237 123.797 291.148C123.797 291.935 123.982 292.565 124.352 293.039C124.727 293.508 125.221 293.742 125.836 293.742C126.461 293.742 126.969 293.518 127.359 293.07C127.75 292.617 127.945 292.039 127.945 291.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.707 289.707C239.098 289.317 239.098 288.683 238.707 288.293L232.343 281.929C231.953 281.538 231.319 281.538 230.929 281.929C230.538 282.319 230.538 282.953 230.929 283.343L236.586 289L230.929 294.657C230.538 295.047 230.538 295.681 230.929 296.071C231.319 296.462 231.953 296.462 232.343 296.071L238.707 289.707ZM213 290H238V288H213V290Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_270_831",
    x: 4.55298,
    y: 14.125,
    width: 44.7938,
    height: 39.1038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_270_831",
    x: 84.7654,
    y: -4.99194,
    width: 37.9641,
    height: 49.9133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_270_831",
    x: 102.052,
    y: 111.734,
    width: 51.7224,
    height: 31.6418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_270_831",
    x: 11.8064,
    y: 142.504,
    width: 37.9296,
    height: 46.6333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_270_831",
    x: 47.6919,
    y: 73.4216,
    width: 30.8284,
    height: 51.6744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_270_831",
    x: 144,
    y: 38,
    width: 30,
    height: 51.4773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_270_831",
    x: 52.7859,
    y: 220.181,
    width: 41.3224,
    height: 43.7104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_270_831",
    x: 82.999,
    y: 160.661,
    width: 34.8518,
    height: 50.6262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_270_831",
    x: 197.953,
    y: 204.098,
    width: 30.0999,
    height: 51.6887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_270_831",
    x: 214.786,
    y: 109.181,
    width: 41.3225,
    height: 43.7104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_270_831",
    x: 153.786,
    y: 150.181,
    width: 41.3225,
    height: 43.7103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_270_831",
    x: 196.63,
    y: 11.9818,
    width: 38.4041,
    height: 45.6095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 279,
    height: 364,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollorCard);
export default __webpack_public_path__ + "static/media/dollor_card.f68e1ad64e400137c441d052630ba77e.svg";
export { ForwardRef as ReactComponent };